import httpClient from 'utils/httpClient.js';
import { withPortalScope } from 'utils/portalScope';
import { createRequestKey, dedupeRequest } from 'utils/dedupeRequest';

const path = '/promotion';

export const getList = (params) => {
  return httpClient.get(`${path}`, { params: withPortalScope(params) });
};

export const getDetail = (id) => {
  return httpClient.get(`${path}/${id}`);
};
export const create = (params) => {
  return httpClient.post(`${path}`, params);
};
export const update = (id, params) => {
  return httpClient.put(`${path}/${id}`, params);
};

export const deletePromotion = (list_id) => {
  return httpClient.delete(`${path}`, { data: list_id });
};

export const getTotalPromotion = (params) => {
  return httpClient.get(`${path}/total-option`, { params });
};

export const getComboOptions = (params) => {
  const scopedParams = withPortalScope(params);
  return dedupeRequest(
    createRequestKey('promotion-combo-options', scopedParams),
    () => httpClient.get(`${path}/combo-options`, { params: scopedParams }),
    { cacheTimeMs: 1000 },
  );
};

export const getComboTypes = (params) => {
  return httpClient.get(`${path}/combo-types`, { params });
};

export const getComboProductOptions = (params) => {
  return httpClient.get(`${path}/combo-product-options`, { params: withPortalScope(params) });
};

export const getComboDetail = (id, params) => {
  return httpClient.get(`${path}/combo/${id}`, { params: withPortalScope(params) });
};

export const createCombo = (params) => {
  return httpClient.post(`${path}/combo`, withPortalScope(params));
};

export const updateCombo = (id, params) => {
  return httpClient.put(`${path}/combo/${id}`, withPortalScope(params));
};

export const deleteCombo = (params) => {
  return httpClient.delete(`${path}/combo`, { data: params });
};

export const importComboExcel = (file) => {
  const formData = new FormData();
  formData.append('combo_import', file);
  return httpClient.post(`${path}/combo/import-excel`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const approveReview = (idPromotion, params) => {
  return httpClient.put(`${path}/${idPromotion}/approve`, params);
};

export const stopPromotion = (idPromotion, params) => {
  return httpClient.put(`${path}/${idPromotion}/stop`, params);
};

export const changePromotionLifecycle = (id, params) => httpClient.put(`${path}/${id}/lifecycle`, params);
